import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { AuthAPIMService } from 'src/app/services/authAPIMService/authAPIM.service';

@Component({
  selector: 'home',
  templateUrl: 'home.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HomeComponent {
  userName: string | undefined;
  
  constructor(
    private msalService: MsalService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    // Set the initial username
    this.updateUserName();

    // Subscribe to MSAL events to detect authentication changes
    this.msalService.instance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACCOUNT_ADDED) {
        const authResult = event.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(authResult.account);
        this.updateUserName();

        this.router.navigate(['/lib-editor'])
      }
    });

    if (this.msalService.instance.getActiveAccount() !== null) {
      this.router.navigate(['/lib-editor'])
    }
  }

  private updateUserName(): void {
    this.userName = this.msalService.instance.getActiveAccount()?.name;
  }

}
